import React from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { useLoginFinalization } from '../hooks';
export const LoginFinalize = ({ postLoginRedirectUri }) => {
    useLoginFinalization({ postLoginRedirectUri });
    return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
        React.createElement(Text, null, "Please wait while your login is finalized..."),
        React.createElement(LinearProgress, { style: { marginVertical: 10 } })));
};
//# sourceMappingURL=LoginFinalize.js.map